import {
  Box,
  Flex,
  Heading,
  Image,
  Link,
  Text,
  useColorMode,
} from "@chakra-ui/react";
import { getCurrentColor } from "../../constants";

const VendorBanner = () => {
  const { colorMode } = useColorMode();
  return (
    <Box
      px={{ base: 2, md: 4, lg: 6 }}
      py={{ base: 4, md: 6 }}
      bg={getCurrentColor(colorMode, "whiteC.100", "grayC.1700")}
      borderRadius="5px"
      w={"100%"}
    >
      <Flex align="center" justifyContent={"flex-start"}>
        <Box mr={6} w="170px" h={"170px"}>
          <Image
            w={"100%"}
            h={"100%"}
            src={
              "https://d337jieq2masmw.cloudfront.net/Aguila%20Brand%20Page.png"
            }
            alt="Aguila Logo"
            loading="lazy"
          />
        </Box>
        <Box maxW={"70%"}>
          <Heading
            as="h1"
            fontSize={{ base: "xl", md: "32px" }}
            fontWeight="600"
          >
            Shop Official Aguila Products From All Vendors
          </Heading>
          <Text mt={1} color={"blueC.100"}>
            Aguila Ammunition is a globally recognized manufacturer known for
            producing high-quality centerfire, rimfire, and shotshell
            ammunition. With a legacy of craftsmanship and innovation, Aguila
            serves military, law enforcement, and civilian markets with products
            that meet rigorous performance standards.{" "}
          </Text>
        </Box>
      </Flex>
    </Box>
  );
};

export default VendorBanner;
